import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website',
  jsonLd
}) => {
  const location = useLocation();
  const siteUrl = 'https://galo-bet.com';
  const currentUrl = `${siteUrl}${location.pathname}`;
  
  const defaultTitle = 'Galo Bet - Comparateur de Sites de Paris en Ligne en France';
  const defaultDescription = 'Galo Bet est votre comparateur indépendant pour les paris sportifs en ligne en France. Comparez les meilleures offres, bonus et sites agréés ANJ.';
  const defaultImage = `${siteUrl}/images/stephen-baker-QAX5Ylx-lKo-unsplash.webp`;
  
  const pageTitle = title ? `${title} | Galo Bet` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageImage = image || defaultImage;
  
  useEffect(() => {
    // Update document title
    document.title = pageTitle;
    
    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };
    
    // Update basic meta tags
    updateMetaTag('description', pageDescription);
    updateMetaTag('keywords', keywords || 'paris sportifs, sites de paris français, comparateur paris en ligne, bonus paris sportifs, ANJ, paris en ligne France, guides paris, avis sites paris');
    
    // Update Open Graph tags
    updateMetaTag('og:title', pageTitle, true);
    updateMetaTag('og:description', pageDescription, true);
    updateMetaTag('og:image', pageImage, true);
    updateMetaTag('og:url', currentUrl, true);
    updateMetaTag('og:type', type, true);
    
    // Update Twitter tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:title', pageTitle, true);
    updateMetaTag('twitter:description', pageDescription, true);
    updateMetaTag('twitter:image', pageImage, true);
    
    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', currentUrl);
    
    // Update or create JSON-LD script
    if (jsonLd) {
      let jsonLdScript = document.getElementById('json-ld-data');
      if (!jsonLdScript) {
        jsonLdScript = document.createElement('script');
        jsonLdScript.id = 'json-ld-data';
        jsonLdScript.type = 'application/ld+json';
        document.head.appendChild(jsonLdScript);
      }
      jsonLdScript.textContent = JSON.stringify(jsonLd);
    }
  }, [pageTitle, pageDescription, pageImage, currentUrl, type, keywords, jsonLd]);
  
  return null;
};

export default SEO;

